import { render, staticRenderFns } from "./_slugPost.vue?vue&type=template&id=52859ea7&"
import script from "./_slugPost.vue?vue&type=script&lang=ts&"
export * from "./_slugPost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogSinglePost: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/blog/single-post/BlogSinglePost.vue').default,CommonTextBlock: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonTextBlock.vue').default,AcquisitionFAQ: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/acquisition/AcquisitionFAQ.vue').default})
